<template>
  <el-tabs v-model="tabName" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="实际承运人授权" name="driver">
      <driverList v-if="isdriverShow" ref="driverRef" />
    </el-tab-pane>
    <el-tab-pane label="托运人授权" name="shipment">
      <shipmentList v-if="isshipmentShow" ref="shipmentRef" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import driverList from "./driverList.vue";
import shipmentList from "./shipmentList.vue";
export default {
  name: "AddShipmentForm",
  components: { shipmentList, driverList },
  data() {
    return {
      tabName: "driver",
      isdriverShow: false,
      isshipmentShow: false
    };
  },
  created() {
    this.isdriverShow = true;
  },
  methods: {
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
      });
    }
  }
};
</script>
